<!-- ConfirmModal.vue -->
<template>
  <div
    class="modal fade count-confirm-modal"
    id="confirm-modal"
    tabindex="-1"
    role="dialog"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="count-modal-icon material-icons" aria-hidden="true">help_outline</span>
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="count-modal-close"
            data-dismiss="modal"
            aria-label="Close"
            @click="decline"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{ message }}
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="count-modal-secondary"
            @click="decline"
            data-dismiss="modal"
          >
            {{ $englishPreferred ? "Cancel" : "Annuller" }}
          </button>
          <button type="button" class="count-modal-primary" @click="confirm">
            {{ $englishPreferred ? "Confirm" : "Bekræft" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  props: {
    title: String,
    message: String,
  },
  data() {
    return {
      confirmModal: null,
    };
  },
  methods: {
    confirm() {
      console.log("confirmed");
      this.$emit("confirmed");
      this.confirmModal.hide();
    },
    decline() {
      console.log("declined");
      this.$emit("declined");
      this.confirmModal.hide();
    },
  },
  mounted() {
    this.confirmModal = new Modal(document.getElementById("confirm-modal"), {});
    this.confirmModal.show();
  },
};
</script>
